import { Badge } from "antd";
import { theme } from "../../../../theme";

interface OperatinTagsProps {
  isOperating?: boolean;
}

export const OperatinTags: React.FC<OperatinTagsProps> = ({ isOperating }) => {
  return (
    <>
      {isOperating !== undefined ? (
        <Badge
          color={isOperating ? theme.colors.mainPrimary3 : theme.colors.gray4}
          text={isOperating ? "운영중" : "미운영"}
          style={{
            color: isOperating ? theme.colors.mainPrimary3 : theme.colors.gray4,
          }}
        />
      ) : (
        "-"
      )}
    </>
  );
};
